import React from 'react';
import useResizeObserver from 'use-resize-observer';
import get from 'lodash/get';

import Temperature from '../../plots/Temperature';
import Windspeed from '../../plots/Windspeed';
import { Wrapper, Header, Title, Content, ConfigButton } from './Panel.style'
import Options from '../Options';
import WindspeedField from '../../plots/WindspeedField';
import Humidity from '../../plots/Humidity';
import DewPoint from '../../plots/DewPoint'
import SolarRadiation from '../../plots/SolarRadiation';
import Nodes from '../../plots/Nodes';
import TempHum from '../../plots/TempHum';
import Scrolling from '../../plots/Scrolling';

const types = {
  temperatureText: Temperature,
  windspeed: Windspeed,
  windspeedField: WindspeedField,
  humidity: Humidity,
  dewPoint: DewPoint,
  solarRadiation: SolarRadiation,
  nodes: Nodes,
  tempHum: TempHum,
  scrolling: Scrolling,
}


function Panel({ title, type, options, switchType, config }) {
  const Visual = types[type];
  const [ref, width, height] = useResizeObserver();
  // TODO: Revert title for prod
  return (
    <Wrapper>
      <Header>
        <Title>{config.title || title}</Title>
        <ConfigButton onClick={() => switchType(null)}/>
      </Header>
      <Content ref={ref}>
        {Visual
          ? <Visual size={{ height, width }} config={config} />
          : <Options options={options} selectOption={switchType} />
        }
      </Content>
    </Wrapper>
  );
}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/Panel/Panel.component.js